import {createContext} from "react";

const ContextRouter=createContext();
export default  ContextRouter;